import { FC } from 'react';
import './Loading.css';

export type LoadingProps = { text?: string; small?: boolean };

export const Loading: FC<LoadingProps> = ({ text, small }: LoadingProps) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className={`loading ${small ? 'small' : ''}`}>
        <div className="bg-blue-200 opacity-50 loading-bounce1" />
        <div className="bg-blue-200 opacity-50 loading-bounce2" />
      </div>
      {text ? (
        <div className="mt-1 font-semibold text-blue-200 whitespace-nowrap">
          {text}
        </div>
      ) : null}
    </div>
  );
};
